import React from 'react';
import { ProductListProps } from '../types/components';
import ImageWithBaseApi from '../../../../core/img/ImageWithBaseApi';

const ProductList = ({ products, decreaseQuantity, increaseQuantity }: ProductListProps) => {
    return (
        <div className="form-group">
            <h5 className="mb-2">Productos Seleccionados</h5>
            <ul className="list-group">
                {products.map((product: any) => (
                    <li key={product.id} className="list-group-item">
                        <div className="d-flex align-items-center">
                            {product.image && (
                                <ImageWithBaseApi routeName="packet" src={product.image} alt={product.title} className="me-2 p-1" style={{ width: '60px', height: '60px' }} />
                            )}
                            <div>
                                <h6 className="mb-0">
                                    {product.amountDiscount ? (
                                        <>
                                            <span style={{ textDecoration: 'line-through' }}>S/.{product.price}</span> - S/.{(product.price * product.quantity) - product.amountDiscount}
                                        </>
                                    ) : (
                                        `S/.${product.price * product.quantity}`
                                    )}
                                </h6>
                                {product.amountDiscount > 0 && (
                                    <>
                                        <small className="text-success">Descuento: S/.{product.amountDiscount}</small>
                                        <br />
                                    </>
                                )}
                                <small>{product.subtitle}</small>
                            </div>
                            <div className="ms-auto">
                                <button className="btn btn-sm btn-outline-secondary me-2" onClick={() => decreaseQuantity(product.id)}>-</button>
                                <span>{product.quantity}</span>
                                <button className="btn btn-sm btn-outline-secondary ms-2" onClick={() => increaseQuantity(product.id)}>+</button>
                            </div>
                        </div>
                    </li>
                ))}
            </ul>
        </div>
    )
}

export default ProductList;